// extracted by mini-css-extract-plugin
module.exports = {"container":"FullViewSpinnerWrapper_container__t8Q_w"};